import React from 'react';

import MenuMain from '../../MenuMain';
import { AppFooter } from '../../AppFooter';
import { TabelaPessoa } from '../../components/TabelaPessoa';

export default function PessoaPage() {

    return (
        <>           
            <MenuMain >
                <TabelaPessoa />
            </MenuMain>
            <AppFooter />    
        </>
    );
}
